module.exports = __webpack_public_path__ + "static/media/erwatodaylogo.748a61a1.png";